import React from 'react';
import { useSelector } from 'react-redux';
import PageTitle from '../headers/PageTitle';
import UploadFilesButton from './UploadFilesButton';
import AddFolderButton from './AddFolderButton';
import FilesTreeView from './FilesTreeView';
import { WORKSPACE_TYPES } from '../../types/workspace';
import { FileScopeType } from './hooks/useGetAllFiles';

// Org-level file library. Mirrors the incident FilesPage but scopes everything to the currently
// selected organization (group_guid) and tags requests with scopeType='organization' so the
// backend stores org-scoped files and enforces org file permissions. The underlying file
// components are reused unchanged — only the owner/scope differ.
const ORG_SCOPE: FileScopeType = WORKSPACE_TYPES.ORG;

const OrgFilesPage: React.FC = () => {
  const groupGuid = useSelector(
    (state: any) =>
      state.app.currentlySelectedGroup?.group_guid as string | undefined
  );

  if (!groupGuid) {
    return (
      <div className="files-page maincontent">
        <PageTitle title="Organization Files" parents={['Organization']} />
        <div className="tab-wrapper content-gap-none p-4">
          <p>Select an organization to view its files.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="files-page maincontent">
      <PageTitle title="Organization Files" parents={['Organization']}>
        <div className="d-flex align-items-center flex-column flex-md-row mb-3 mb-lg-0">
          <UploadFilesButton
            ownerId={groupGuid}
            scopeType={ORG_SCOPE}
            showNotificationText={false}
            showTooltip={false}
          />
          <AddFolderButton
            ownerId={groupGuid}
            scopeType={ORG_SCOPE}
            className="button--primary mt-2 mt-md-0 ms-md-2"
          />
        </div>
      </PageTitle>
      <div className="tab-wrapper content-gap-none">
        <FilesTreeView ownerId={groupGuid} scopeType={ORG_SCOPE} />
      </div>
    </div>
  );
};

export default OrgFilesPage;
